// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"160207b7","722":"160207b7","826":"992e8e78"}[chunkId] + ".chunk.css";
};